export function AxiosErrorException (err) {
	let errorJSON = err.response.data.errors;      
	let errorStr = "";

	if(errorJSON) {
		Object.keys(errorJSON).forEach((item) => {
			errorStr += errorJSON[item][0] + "\n";
		})
	}

	return errorStr
}